import { Grid } from '@material-ui/core'

import { useEffect } from 'react'

import { LoaderBackdrop } from 'asterX-UI/Loaders'
import { Pagination } from 'asterX-UI/Pagination'

import { OKTELL } from 'constants/deals'
import { useWorkListStoreManager } from 'context/HomeStore/Manager/WorkListsProvider/WorkListProvider.manager'
import Card from 'pages/Desktop/Home/Manager/components/WorkLists/Card/Card'
import TabsWl from 'pages/Desktop/Home/Manager/components/WorkLists/Tabs/TabsWl'
import Filter from './Filter/Filter'

const WorkListTab = () => {
  const { workListStore, workListStoreFunc } = useWorkListStoreManager()

  const onPaginationChange = (_, page) => {
    page = page === 0 ? page : page - 1
    workListStoreFunc.onPaginationChange(page)
  }

  useEffect(() => {
    if (workListStore.selectedTab === OKTELL) {
      workListStoreFunc.getListWl()()
    }
  }, [workListStore.selectedTab])

  return (
    <Grid container spacing={2}>
      <LoaderBackdrop loading={workListStore.loading} />

      <Grid item xs={12} md={12}>
        <Filter />
      </Grid>

      <Grid item xs={12} md={12}>
        <TabsWl />
      </Grid>

      <Grid item xs={12} md={12}>
        {workListStore?.list?.map((item, i) => (
          <Card key={`card_container_${i}`} workList={item} />
        ))}
      </Grid>

      <Grid item xs={12} md={12}>
        <Pagination
          isMobile
          count={workListStore?.pagination?.pageCount}
          page={workListStore?.pagination?.page + 1}
          onChange={onPaginationChange}
        />
      </Grid>
    </Grid>
  )
}

export default WorkListTab
